import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import type React from 'react';

interface AssistantConnectStepProps {
  index: number;
  title: string;
  children?: React.ReactNode;
}

/** One numbered step of the connect dialog: a counter, a sentence, then its control. */
export const AssistantConnectStep: React.FC<AssistantConnectStepProps> = ({
  index,
  title,
  children,
}) => (
  <Flex gap={3} align="flex-start">
    <Box
      flex="none"
      boxSize={6}
      rounded="full"
      bg="lilac.100"
      color="lilac.700"
      display="grid"
      placeItems="center"
      fontSize="xs"
      fontWeight="semibold"
    >
      {index}
    </Box>
    <Stack gap={2.5} flex="1" minW={0} pt="2px">
      <Text fontSize="sm" color="fg">
        {title}
      </Text>
      {children}
    </Stack>
  </Flex>
);
